<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
    ></app-gridview>
  </div>
</template>
<script>
import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('latenessdeduction.records'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('latenessdeduction.batchcode'), value: "batchcode", width: "120px" },
        { text: this.$t('latenessdeduction.batchdesc'), value: "batchdesc", width: "200px" },
        { text: this.$t('latenessdeduction.batchfromdate'), value: "fromdate", width: "120px" },
        { text: this.$t('latenessdeduction.batchtodate'), value: "todate", width: "120px" },
        { text: this.$t('latenessdeduction.latenesspolicyparameter'), value: "latenesspolicydesc", width: "200px" },
        { text: this.$t('latenessdeduction.recordscount'), value: "recordcount", width: "50px" },
        { text: this.$t('columns.totalamount'), value: "totalamount", width: "50px" },
       
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getLatenessBatchHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/attnlatenessbatch/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          for (let i = 0; i < vm.dataItems.length; i++) {
            if (vm.dataItems[i].fromdate) {
              vm.dataItems[i].fromdate = moment(vm.dataItems[i].fromdate).format('YYYY-MM-DD');
            }
            if (vm.dataItems[i].todate) {
              vm.dataItems[i].todate = moment(vm.dataItems[i].todate).format('YYYY-MM-DD');
            }
          }
          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "latenessdeductiondetailslisting", params: { id: item.id, search: item.search } });
    },

    // newRecordHandler() {
    //   this.$router.push({ name: "latenessdeductionpolicynew" });
    // },
  },
  mounted() {
    this.getLatenessBatchHandler();
  },
};
</script>